module.exports = __webpack_public_path__ + "static/media/Headshot.8cb7dbcc.png";